import { Stack, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { ConditionLink, ImportedConditionLink } from '@/models/conditionLink';
import { ConditionLinkGeneralDataCard } from '@/pages/rulesets/components/ConditionLinkGeneralDataCard';

type ConditionLinkGeneralDataProps = {
    conditionLink: ConditionLink | ImportedConditionLink;
};

export const ConditionLinkGeneralData: FunctionComponent<
    ConditionLinkGeneralDataProps
> = ({ conditionLink }) => {
    return (
        <Stack spacing={2}>
            <Typography
                sx={{
                    width: '75%',
                }}
            >
                Hier können Sie allgemeine Daten für das Regelwerk festlegen.
                Bitte beachten Sie, um eine Kontingent - oder Preisregel zu
                erstellen, müssen Sie erst einen Namen für das Regelwerk angeben
                und speichern.
            </Typography>

            <ConditionLinkGeneralDataCard conditionLink={conditionLink} />
        </Stack>
    );
};
